module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-panel"
  }, [_c('div', {
    staticClass: "group-heading",
    class: {
      collapsed: _vm.collapsed || !_vm.itemCount
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('div', {
    staticClass: "group-heading-label"
  }, [_vm._v(_vm._s(_vm.groupTitle) + "\n            "), (_vm.itemCount && !_vm.readOnly) ? _c('v-icon', {
    staticClass: "collapse-button",
    class: {
      collapsed: _vm.collapsed
    },
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-up")]) : _vm._e()], 1), _vm._v(" "), (!_vm.readOnly) ? _c('div', {
    staticClass: "group-heading-buttons",
    class: {
      collapsed: _vm.collapsed
    }
  }, [(_vm.itemCount) ? _c('div', {
    staticClass: "group-heading-button",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.subtract($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-minus")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group-heading-button",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")])], 1)]) : _vm._e()]), _vm._v(" "), _c('v-expand-transition', [(_vm.schema && !_vm.collapsed) ? _c('div', [_c('draggable', {
    staticClass: "draggable-container",
    class: {
      columns: _vm.schema.columns, 'read-only': _vm.readOnly
    },
    attrs: {
      "value": _vm.value,
      "animation": "350",
      "group": "elements",
      "handle": ".menu-handle"
    },
    on: {
      "input": _vm.draggableInput
    }
  }, _vm._l((_vm.value), function(record, recordIndex) {
    return _c('div', {
      key: recordIndex,
      staticClass: "group-item-area",
      class: {
        'read-only': _vm.readOnly
      },
      style: (_vm.columnStyle)
    }, [(!_vm.readOnly) ? _c('div', {
      staticClass: "menu-handle",
      staticStyle: {
        "position": "absolute",
        "right": "-2px",
        "top": "5px"
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "grey lighten-1"
            }
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteItem(recordIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "inputs-area"
    }, [_c('ControlList', {
      attrs: {
        "horizontal": _vm.schema.horizontal,
        "schema": _vm.schemaFields,
        "value": record
      },
      on: {
        "change": function($event) {
          var i = arguments.length, argsArray = Array(i);
          while ( i-- ) argsArray[i] = arguments[i];

          return _vm.emitChanges.apply(void 0, argsArray.concat( [recordIndex] ))
        }
      }
    })], 1)])
  }), 0)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-464ae727"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/controls/GroupControl.vue
// module id = 2529
// module chunks = 1